import comp from "./MicrosoftPicker";
export default comp;
